import React, { useState, useEffect, useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
  Button,Switch 
} from "devextreme-react/data-grid";
import Guid from "devextreme/core/guid";
import { MultiSelect } from "react-multi-select-component";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import TextField from "@material-ui/core/TextField";
import { useStyles } from "../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import swal from "sweetalert";
import Button1 from "@material-ui/core/Button";
import Select from "react-select";
import { useNavigate } from "react-router";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import "../dropdownstyle.css";
import { api_path } from "../shared";
import RadioButton from "./RadioButton2.jsx";
import ServicesContractLogItemView from "./ServicesContractLogItemView";
import useDeviceSize from "../hooks/useDeviceSize";
export function ServiceContractManagementDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const [modeSize, setModeSize] = useState("widget");
  const classes = useStyles();
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const [getStatus, setStatus] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [getTradLane, setTradLane] = useState([]);
  const [selectTradLane, setSelectTradLane] = useState([]);
  const [getTrad2, setTrad2] = useState([]);
  const [selectTrad2, setSelectTrad2] = useState([]);
  const [getCarrier, setCarrier] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const [selectCarrier, setSelectCarrier] = useState([]);
  const [getCarrier2, setCarrier2] = useState([]);
  const [carrierList2, setCarrierList2] = useState([]);
  const [selectCarrier2, setSelectCarrier2] = useState([]);
  const [getCarrierSearch, setCarrierSearch] = useState([]);
  const [carrierListSearch, setCarrierListSearch] = useState([]);
  const [selectCarrierSearch, setSelectCarrierSearch] = useState([]);
  const [getSpecialFlag, setSpecialFlag] = useState([]);
  const [selectSpecialFlag, setSelectSpecialFlag] = useState([]);
  const [GET_ACTIVE_STATUS, SET_ACTIVE_STATUS] = useState("1");
  const [GET_ACTIVE_STATUS_SEARCH, SET_ACTIVE_STATUS_SEARCH] = useState("1");
  const [GET_SPECIAL_FLAG, SET_SPECIAL_FLAG] = useState("1");
  const [getSpecialFlag2, setSpecialFlag2] = useState([]);
  const [selectSpecialFlag2, setSelectSpecialFlag2] = useState([]);
  const [GET_SC_SEARCHBOX, SET_SC_SEARCHBOX] = useState("");
  const [GET_BL_SEARCHBOX, SET_BL_SEARCHBOX] = useState("");
  const [GET_COPY_ID, SET_COPY_ID] = useState(0);
  const [GET_SERVICE_CONTRACT_ID, SET_SERVICE_CONTRACT_ID] = useState();
  const [GET_SERVICS_CONTRACT, SET_SERVICS_CONTRACT] = useState();
  const [GET_BULLET_CODE, SET_BULLET_CODE] = useState();
  const [GET_BOND, SET_BOND] = useState();
  const [GET_DESCRIPTION, SET_DESCRIPTION] = useState();
  const [GET_VALIDITY, SET_VALIDITY] = useState();
  const [getLoadGrid, setLoadGrid] = useState();
  const [showComment, setShowComment] = useState(false);
  const handleCloseModal = () => setShowComment(false);
  const handleShowComment = () => setShowComment(true);
  const [showLog, setShowLog] = useState(false);
  const handleCloseLog = () => setShowLog(false);
  const handleShowLog = () => setShowLog(true);
  const [logData, setLogData] = useState([]);
  const navigate = useNavigate();
  const [GET_SUBJECT, SET_SUBJECT] = useState();
  const url =
    api_path +
    "/MS_SERVICES_CONTRACT_FORM.php?trade=" +
    selectTradLane +
    "&carrier=" +
    selectCarrierSearch +
    "&sc=" +
    GET_SC_SEARCHBOX +
    "&bl=" +
    GET_BL_SEARCHBOX +
    "&status=" +
    GET_ACTIVE_STATUS_SEARCH +
    "&flag=" +
    selectSpecialFlag2 +
    "&load=" +
    getLoadGrid;
  const dataSource = createStore({
    key: "SERVICE_CONTRACT_ID",
    loadUrl: `${url}`,
  });
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const handleCarrierChange = (obj) => {
    setSelectCarrier(obj.value);
    setCarrier({
      value: obj.value,
      label: obj.label,
    });
  };

  useEffect(() => {
    const getCarrierDropdown = async () => {
      const resstate = await fetch(api_path + `/MS_CARRIER.php`);
      const getst = resstate.json();
      setCarrierList(await getst);
      setCarrierList2(await getst);
      setCarrierListSearch(await getst);
    };
    getCarrierDropdown().then();
  }, []);
  const handleCarrierListChangeSearch = (obj) => {
    setSelectCarrierSearch(obj.value);
    setCarrierSearch({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleCarrierListChange = (obj) => {
    setSelectCarrier(obj.value);
    setCarrier({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleCarrierListChange2 = (obj) => {
    setSelectCarrier2(
      Array.isArray(obj) ? obj.map((x) => x.value).join(",") : []
    );
    setCarrier2({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleTradListChange = (obj) => {
    if (obj) {
      setSelectTrad2(obj.value);
      setTrad2({ value: obj.value, label: obj.label });
    } else {
      setSelectTrad2([]);
      setTrad2([]);
    }
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const handleFlagSearchChange = (obj) => {
    setSelectSpecialFlag2(obj.value);
    setSpecialFlag2({ value: obj.value, label: obj.label });
  };
  const handleTradLaneChange = (obj) => {
    setSelectTradLane(obj.value);
    setTradLane({ value: obj.value, label: obj.label });
  };
  const handleSpecialFlagChange = (obj) => {
    setSelectSpecialFlag(obj.value);
    setSpecialFlag({ value: obj.value, label: obj.label });
  };

  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };

  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "ServiceContract.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const options = [
    { value: "", label: "ALL" },
    { value: "TP", label: "TP" },
    { value: "NON-TP", label: "NON-TP" },
  ];
  const tradList2 = [
    { value: "TP", label: "TP" },
    { value: "NON-TP", label: "NON-TP" },
  ];
  const specialFlagList = [
    { value: "1", label: "Normal" },
    { value: "2", label: "Special" },
    { value: "3", label: "Red" },
  ];
  const optionsStatus = [
    // { value: "", label: "ALL" },
    { value: "1", label: "ACTIVE" },
    { value: "0", label: "INACTIVE" },
  ];
  const optionsSpecialFlagList2 = [
    { value: "", label: "All" },
    { value: "1", label: "Normal" },
    { value: "2", label: "Special" },
    { value: "3", label: "Red" },
  ];
  const onDeleteButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    swal({
      title: "Are you sure to delete this item ?",
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        del(e.row.key);
      }
    });
  }, []);
  const del = async (id) => {
    try {
      const response = await axios.delete(
        api_path + `/MS_SERVICES_CONTRACT_FORM.php?id=${id}`
      );
      setLoadGrid(randomNumberInRange(1, 20));
    } catch (error) {
      console.error(error);
    }
  };
  const onCopyButtonClick = React.useCallback((e) => {
    SET_SUBJECT("Copy Services Contract");
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    setShowComment(true);
    SET_COPY_ID(1);
    SET_SERVICE_CONTRACT_ID(0);

    setTrad2({
      value: dataRow.TRADE_LANE,
      label: dataRow.TRADE_LANE,
    });
    setSelectTrad2(dataRow.TRADE_LANE);

    if (dataRow.SPECIAL_FLAG == 1) {
      setSelectSpecialFlag("1");
      setSpecialFlag({
        value: "1",
        label: "Normal",
      });
    } else {
      setSelectSpecialFlag(dataRow.SPECIAL_FLAG);
      setSpecialFlag({
        value: dataRow.SPECIAL_FLAG,
        label: dataRow.FLAG_NAME,
      });
    }
    setCarrier2({
      value: dataRow.CARRIER_CODE,
      label: dataRow.CARRIER_CODE,
    });
    setSelectCarrier2(dataRow.CARRIER_CODE);

    SET_SERVICS_CONTRACT(dataRow.SERVICE_CONTRACT_NO);
    SET_BULLET_CODE(dataRow.BULLET_CODE);
    SET_DESCRIPTION(dataRow.CONDITION);
    SET_VALIDITY(dataRow.VALIDITY);
    SET_ACTIVE_STATUS(dataRow.IS_ACTIVE);
    setRadioStatus(dataRow.IS_ACTIVE);
  }, []);
  const onEditButtonClick = React.useCallback((e) => {
    SET_SUBJECT("Edit Services Contract");
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    setShowComment(true);
    SET_SERVICE_CONTRACT_ID(e.row.key);

    setTrad2({
      value: dataRow.TRADE_LANE,
      label: dataRow.TRADE_LANE,
    });
    setSelectTrad2(dataRow.TRADE_LANE);

    if (dataRow.SPECIAL_FLAG == 1) {
      setSelectSpecialFlag("1");
      setSpecialFlag({
        value: "1",
        label: "Normal",
      });
    } else {
      setSelectSpecialFlag(dataRow.SPECIAL_FLAG);
      setSpecialFlag({
        value: dataRow.SPECIAL_FLAG,
        label: dataRow.FLAG_NAME,
      });
    }
    setCarrier({
      value: dataRow.CARRIER_CODE,
      label: dataRow.CARRIER_CODE,
    });
    setSelectCarrier(dataRow.CARRIER_CODE);

    SET_SERVICS_CONTRACT(dataRow.SERVICE_CONTRACT_NO);
    SET_BULLET_CODE(dataRow.BULLET_CODE);
    SET_DESCRIPTION(dataRow.CONDITION);
    SET_VALIDITY(dataRow.VALIDITY);
    SET_ACTIVE_STATUS(dataRow.IS_ACTIVE);
    setRadioStatus(dataRow.IS_ACTIVE);
  }, []);
  const [errors, setErrors] = useState({});
  const validateForm = (SERVICE_CONTRACT_ID) => {
    const errors = {};
    if (selectTrad2.length === 0) {
      errors.tradeErr = "Required";
    }
    // if (SERVICE_CONTRACT_ID == 0) {
    //   if (selectCarrier2.length === 0) {
    //     errors.carrierErr = "Required";
    //   }
    // } else {
    //   if (selectCarrier.length === 0) {
    //     errors.carrierErr = "Required";
    //   }
    // }
  if (selectCarrier.length === 0) {
        errors.carrierErr = "Required";
      }
    if (!GET_SERVICS_CONTRACT) {
      errors.servicescontractErr = "Required";
    }
    return errors;
  };
  function updateServicesContract(
    SERVICE_CONTRACT_ID,
    TRADE_LANE,
    CARRIER_CODE,
    SERVICS_CONTRACT,
    BULLET_CODE,
    DESCRIPTION,
    VALIDITY,
    SPECIAL_FLAG,
    ACTIVE_STATUS
  ) {
    // if (selectSpecialFlag.length === 0 || getSpecialFlag.length === 0) {
    //   SPECIAL_FLAG = "";
    // } else {
    //   SPECIAL_FLAG = selectSpecialFlag;
    // }
    let CARRIERCODE;
    // if (SERVICE_CONTRACT_ID == 0) {
    //   CARRIERCODE = selectCarrier2;
    // } else {
    //   CARRIERCODE = selectCarrier;
    // }
     CARRIERCODE = selectCarrier;
    const newErrors = validateForm(SERVICE_CONTRACT_ID);
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      var data = {
        SERVICE_CONTRACT_ID: SERVICE_CONTRACT_ID,
        TRADE_LANE: TRADE_LANE,
        CARRIER_CODE: CARRIERCODE,
        SERVICS_CONTRACT: SERVICS_CONTRACT,
        BULLET_CODE: BULLET_CODE,
        DESCRIPTION: DESCRIPTION,
        VALIDITY: VALIDITY,
        SPECIAL_FLAG: SPECIAL_FLAG,
        USER_ID: getUserID,
        ACTIVE_STATUS: ACTIVE_STATUS,
      };
      fetch(api_path + "/MS_SERVICES_CONTRACT_FORM.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result["status"] == "200") {
            swal("Done.", "Save data successfully.", "success", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              handleCloseModal();
            });
          } else {
            swal("Sorry", result["message"], "error", {
              buttons: true,
              timer: 5000,
            });
          }
        });
    }
  }
  const handleClearInputClick = () => {
    setSelectCarrier([]);
    setCarrier([]);
    setSelectCarrierSearch([]);
    setCarrierSearch([]);
    setTradLane([]);
    setSelectTradLane([]);
    setSelectStatus([]);
    setStatus([]);
    setSpecialFlag2([]);
    setSelectSpecialFlag2([]);
    SET_SC_SEARCHBOX("");
    SET_BL_SEARCHBOX("");
  };
  const onRefreshClick = useCallback(() => {
    setLoadGrid(randomNumberInRange(1, 20));
  }, []);
  const handleAddButtonClick = useCallback((e) => {
    SET_SUBJECT("Add Services Contract");
    setShowComment(true);
    SET_SERVICE_CONTRACT_ID(0);
    setSelectCarrier2([]);
    setCarrier2([]);
    setTrad2([]);
    setSpecialFlag2([]);
    setSelectSpecialFlag2([]);
    setSelectTrad2([]);
    SET_SERVICS_CONTRACT("");
    SET_BULLET_CODE("");
    SET_DESCRIPTION("");
    SET_VALIDITY("");
    SET_ACTIVE_STATUS("1");
    setRadioStatus("1");
  }, []);
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "IS_ACTIVE") {
        if (e.data.IS_ACTIVE == 1) {
          e.cellElement.innerHTML = "🟢";
          e.cellElement.style.cssText = "text-align:center;";
        } else {
          e.cellElement.innerHTML = "⚫";
          e.cellElement.style.cssText = "text-align:center;";
        }
      }
      if (e.column.dataField === "FLAG_NAME" && e.data.SPECIAL_FLAG == 2) {
        e.cellElement.innerHTML =
          "<p class='status1'>" + e.data.FLAG_NAME + "</p>";
      } else if (
        e.column.dataField === "FLAG_NAME" &&
        e.data.SPECIAL_FLAG == 3
      ) {
        e.cellElement.innerHTML =
          "<p class='status9'>" + e.data.FLAG_NAME + "</p>";
      } else if (
        e.column.dataField === "FLAG_NAME" &&
        e.data.SPECIAL_FLAG == 1
      ) {
        e.cellElement.innerHTML =
          "<p class='status0'>" + e.data.FLAG_NAME + "</p>";
      }
      if (e.column.dataField === "CONDITION" && e.data.SPECIAL_FLAG == 2) {
        e.cellElement.style.cssText = "text-align:left;color:red;";
      } else if (
        e.column.dataField === "CONDITION" &&
        e.data.SPECIAL_FLAG == 3
      ) {
        e.cellElement.style.cssText = "text-align:left;color:red;";
      } else if (
        e.column.dataField === "CONDITION" &&
        e.data.SPECIAL_FLAG == 0
      ) {
        e.cellElement.style.cssText = "text-align:left;";
      }
      if (e.column.dataField === "ORDER_NO") {
        e.cellElement.innerHTML =
          "<p style='color: #000;background-color: #EBEBEB;text-align:center;margin:8px;'><a href='SalesOrderDetail?order_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #000;'>" +
          e.data.ORDER_NO +
          "</a></p>";
      }
    }
  };
  const isChecked = (value) => radioRoleStatus === value;
  const [radioRoleStatus, setRadioStatus] = useState("1");
  const handleRadioChange = (event) => {
    setRadioStatus(event.target.value);
    if (event.target.value == "1") {
      SET_ACTIVE_STATUS("1");
    } else if (event.target.value == "0") {
      SET_ACTIVE_STATUS("0");
    }
  };

  const isChecked2 = (value) => radioStatusSearch === value;
  const [radioStatusSearch, setRadioStatusSearch] = useState("1");
  const handleRadioChangeSearch = (event) => {
    setRadioStatusSearch(event.target.value);
    if (event.target.value == "1") {
      SET_ACTIVE_STATUS_SEARCH("1");
    } else if (event.target.value == "0") {
      SET_ACTIVE_STATUS_SEARCH("0");
    }
  };

  function onShowlogButtonClick(e) {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    fetchItemData(e.row.key);
    setShowLog(true);
  }
  const showLogData = true;
  const fetchItemData = async (SERVICE_CONTRACT_ID) => {
    const response = await fetch(
      api_path +
        "/GET_SERVICES_CONTRACT_LOG.php?SERVICE_CONTRACT_ID=" +
        SERVICE_CONTRACT_ID
    );
    const data = await response.json();
    setLogData(data);
  };
  function DisplayLogData(props) {
    if (props.logData.length > 0) {
      return (
        <table class="table table-Default table-hover">
          <thead>
            <tr>
              <th scope="col">DATE</th>
              <th scope="col">Modified By</th>
              <th scope="col">DETAIL</th>
            </tr>
          </thead>
          {showLogData ? (
            <>
              {logData.map((fdata) => {
                return (
                  <ServicesContractLogItemView
                    key={fdata.SERVICE_CONTRACT_ID}
                    id={fdata.SERVICE_CONTRACT_ID}
                    USERNAME={fdata.USER_FIRSTNAME}
                    EVENT_DATE={fdata.INSERT_DATE}
                    //DATE_TEXT={fdata.DATE_TEXT}
                    REVISED_COLUMNS={fdata.REVISED_COLUMNS}
                  />
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </table>
      );
    } else {
    }
  }
  return (
    <Container maxWidth="xl">
      <Modal
        className="modal"
        show={showLog}
        onHide={handleCloseLog}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Log</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <DisplayLogData logData={logData} />
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button1 variant="secondary" onClick={handleCloseLog}>
            Close
          </Button1>
        </Modal.Footer>
      </Modal>
      <Modal
        className="modal"
        show={showComment}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{GET_SUBJECT}</Modal.Title>
          <Button1 variant="secondary" onClick={handleCloseModal}>
            Close
          </Button1>
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                updateServicesContract(
                  GET_SERVICE_CONTRACT_ID,
                  selectTrad2,
                  selectCarrier,
                  GET_SERVICS_CONTRACT,
                  GET_BULLET_CODE,
                  GET_DESCRIPTION,
                  GET_VALIDITY,
                  selectSpecialFlag,
                  GET_ACTIVE_STATUS
                );
              }}
              id="editmodal"
              className=""
            >
              <Grid container spacing={2}>
                {/* <Grid item xs={12} sm={12}>
                <input
                      type="text"
                      value={GET_SERVICE_CONTRACT_ID}
                      onChange={(e) => SET_SERVICE_CONTRACT_ID(e.target.value)}
                    />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <label>
                    Trade:
                    <Select
                      className="multiselect1"
                      placeholder="Select"
                      value={getTrad2}
                      options={tradList2}
                      onChange={handleTradListChange}
                      required
                    />
                    {errors.tradeErr && (
                      <span className="error-message">{errors.tradeErr}</span>
                    )}
                  </label>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>
                    Carrier:
                    {GET_SERVICE_CONTRACT_ID != 0 &&
                      GET_SERVICE_CONTRACT_ID !== null && (
                        <Select
                          className="multiselect2"
                          placeholder="Select"
                          value={getCarrier}
                          options={carrierList}
                          onChange={handleCarrierListChange}
                          required
                        />
                      )}
                    {GET_SERVICE_CONTRACT_ID == 0 &&
                      GET_SERVICE_CONTRACT_ID !== null && (
                          <Select
                          className="multiselect2"
                          placeholder="Select"
                          value={getCarrier}
                          options={carrierList}
                          onChange={handleCarrierListChange}
                          required
                        />
                        // <MultiSelect
                        //   styles={{
                        //     menu: (provided) => ({
                        //       ...provided,
                        //       zIndex: 10000000,
                        //     }),
                        //   }}
                        //   //className="multiselect"
                        //   options={carrierList2}
                        //   defaultValue={[]}
                        //   value={carrierList2.filter((obj) =>
                        //     selectCarrier2.includes(obj.value)
                        //   )}
                        //   onChange={handleCarrierListChange2}
                        //   labelledBy="Select"
                        //   hasSelectAll={true}
                        //   required
                        // />
                      )}
                    {errors.carrierErr && (
                      <span className="error-message">{errors.carrierErr}</span>
                    )}

                  </label>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>
                    Services Contract:
                    <TextField
                      size="small"
                      name="GET_SERVICS_CONTRACT"
                      variant="outlined"
                      fullWidth
                      id="GET_SERVICS_CONTRACT"
                      value={GET_SERVICS_CONTRACT}
                      onChange={(e) => SET_SERVICS_CONTRACT(e.target.value)}
                    />
                    {errors.servicescontractErr && (
                      <span className="error-message">
                        {errors.servicescontractErr}
                      </span>
                    )}
                  </label>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>
                    Bullet:
                    <TextField
                      size="small"
                      name="GET_BULLET_CODE"
                      variant="outlined"
                      fullWidth
                      id="GET_BULLET_CODE"
                      value={GET_BULLET_CODE}
                      onChange={(e) => SET_BULLET_CODE(e.target.value)}
                    />
                  </label>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <label>Description: </label>
                  <TextField
                    size="small"
                    name="GET_DESCRIPTION"
                    variant="outlined"
                    fullWidth
                    id="GET_DESCRIPTION"
                    value={GET_DESCRIPTION}
                    onChange={(e) => SET_DESCRIPTION(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <label>Validity: </label>

                  <TextField
                    size="small"
                    name="GET_VALIDITY"
                    variant="outlined"
                    fullWidth
                    id="GET_VALIDITY"
                    value={GET_VALIDITY}
                    onChange={(e) => SET_VALIDITY(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label>Special flag: </label>
                  <Select
                    className="multiselect2"
                    placeholder="Select"
                    defaultValue={{ value: "1", label: "Normal" }}
                    value={getSpecialFlag}
                    options={specialFlagList}
                    onChange={handleSpecialFlagChange}
                  />
                </Grid>

                <Grid item xs={12} sm={8}>
                  <label>Status: </label>
                  <RadioButton
                    name="ACTIVE_STATUS"
                    value="1"
                    text="ACTIVE"
                    onChange={handleRadioChange}
                    checked={isChecked("1")}
                  />
                  <RadioButton
                    name="ACTIVE_STATUS"
                    value="0"
                    text="INACTIVE"
                    onChange={handleRadioChange}
                    checked={isChecked("0")}
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Cancle
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
      <br /> <br />
      {/* <Grid container spacing={2}>
        <Grid item xs={12}>
        <div className="option">
          <span>Changes:</span>
          <div id="changes">{changesText}</div>
        </div> *
        <ul>
          {events.map((event, index) => (
            <li key={index}>{event}</li>
          ))}
        </ul> 
        </Grid>
      </Grid> */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          {" "}
          <label className="head">Services Contract Management</label>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          style={{ display: "flex", paddingTop: 20 + "px" }}
          justify="flex-end"
        >
          <Button1
            className="addBtn"
            //disabled={!isButtonDisabled}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            Add New
          </Button1>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={1}>
          <label>TRADE</label>
          <Select
            className="multiselect1"
            placeholder="Select"
            value={getTradLane}
            options={options}
            onChange={handleTradLaneChange}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>CARRIER</label>
          <Select
            className="multiselect2"
            placeholder="Select"
            value={getCarrierSearch}
            options={carrierListSearch}
            onChange={handleCarrierListChangeSearch}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Services contract No</label>
          <TextField
            size="small"
            name="GET_SC_SEARCHBOX"
            variant="outlined"
            fullWidth
            id="GET_SC_SEARCHBOX"
            value={GET_SC_SEARCHBOX}
            onChange={(e) => SET_SC_SEARCHBOX(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Bullet code</label>
          <TextField
            size="small"
            name="GET_BL_SEARCHBOX"
            variant="outlined"
            fullWidth
            id="GET_BL_SEARCHBOX"
            value={GET_BL_SEARCHBOX}
            onChange={(e) => SET_BL_SEARCHBOX(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>Flag: </label>
          <br />
          <Select
                  className="multiselect3"
            placeholder="Select"
            value={getSpecialFlag2}
            options={optionsSpecialFlagList2}
            onChange={handleFlagSearchChange}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <label>Status: </label>
          <br />
          <RadioButton
            name="ACTIVE_STATUS_SEARCH"
            value="1"
            text="ACTIVE"
            onChange={handleRadioChangeSearch}
            checked={isChecked2("1")}
          />
          <RadioButton
            name="ACTIVE_STATUS_SEARCH"
            value="0"
            text="INACTIVE"
            onChange={handleRadioChangeSearch}
            checked={isChecked2("0")}
          />
          {/* <Select
            className="react-select-container"
            placeholder="Select"
            value={getStatus}
            options={optionsStatus}
            onChange={handleStatusChange}
          /> */}
        </Grid>
        <Grid item xs={12} sm={2}>
          <div style={{ paddingTop: 7 + "px" }}>&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="info"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>{" "}
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>
      </Grid>
      {/* <Grid xs="12">
        
        <MultiSelect
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 10000000 }),
          }}
          //className="multiselect"
          options={carrierList2}
          defaultValue={[]}
          value={carrierList2.filter((obj) =>
            selectCarrier2.includes(obj.value)
          )}
          onChange={handleCarrierListChange2}
          labelledBy="Select"
          hasSelectAll={true}
          required
        />
      </Grid> */}
      <Grid container className={classes.root}>
        <DataGrid
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="SERVICE_CONTRACT_ID"
          onExporting={onExporting}
          onCellPrepared={cellPrepared}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
          hoverStateEnabled={true}
        >
          {/* <Editing
            mode="batch"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true}
            changes={state.changes}
            onChangesChange={onChangesChange}
            editRowKey={state.editRowKey}
            onEditRowKeyChange={onEditRowKeyChange}
          />  */}
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />

          <Column dataField="TRADE_LANE" caption="TRADE" />
          <Column dataField="CARRIER_CODE" caption="CARRIER" />
          <Column
            dataField="SERVICE_CONTRACT_NO"
            caption="SERVICE"
            allowHiding={false}
          />
          <Column
            dataField="BULLET_CODE"
            caption="BULLET"
            allowHiding={false}
          />
          <Column dataField="BOND" />

          <Column dataField="CONDITION" caption="DESCRIPTION" />
          <Column dataField="VALIDITY" caption="VALIDITY" />

          <Column
            dataField="LAST_UPDATE"
            caption="Update"
            width={115}
            dataType="date"
            format="dd-MMM-yy hh:mm:ss a"
          />
          <Column dataField="SPECIAL_FLAG" caption="FLAG" visible={false} />
          <Column dataField="FLAG_NAME" caption="FLAG" />
          <Column dataField="IS_ACTIVE" caption="STATUS" />
          <Column type="buttons" caption="Actions" width={100} fixed={true}>
            <Button
              icon="eyeopen"
              onClick={onShowlogButtonClick}
              hint="Click to view log details"
            />
            <Button
              icon="edit"
              onClick={onEditButtonClick}
              hint="Click to update comment"
            />
            <Button
              icon="copy"
              name="copy"
              onClick={onCopyButtonClick}
              hint="Click to copy"
              //visible={isCopyIconVisible}
            />
            <Button
              icon="trash"
              onClick={onDeleteButtonClick}
              hint="Click to view log details"
            />
          </Column>
          <Paging defaultPageSize={50} />
          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
